export const pick = (obj, ...fields) => fields.reduce((accum, currField) => {
  const newObj = accum

  if (obj.hasOwnProperty(currField)) {
    newObj[currField] = obj[currField]
  }

  return newObj
}, {})

export const pickBy = (obj, predicate) => Object.keys(obj).reduce((accum, key) => (
  predicate(obj[key], key) ? { ...accum, [key]: obj[key] } : accum
), {})

export const omit = (obj, ...fieldsToOmit) =>
  Object.keys(obj)
    .filter(key => !fieldsToOmit.includes(key))
    .reduce((accum, key) => ({
      ...accum,
      [key]: obj[key],
    }), {})

export const omitBy = (obj, predicate) => Object.keys(obj).reduce((accum, key) => (
  !predicate(obj[key], key) ? { ...accum, [key]: obj[key] } : accum
), {})

export const omitNoValue = obj => omitBy(obj, value => !value)

export const toArray = obj => Object.keys(obj).map(key => obj[key])

export const mapValues = (obj, mapFunc) => Object.keys(obj).reduce((accum, key) => ({
  ...accum,
  [key]: mapFunc(obj[key], key),
}), {})

export const isEmptyObj = obj => Object.keys(obj).length === 0 && obj.constructor === Object
